export enum CourierBalancesTypeEnum {
  general = 'general',
  individual = 'individual',
}
